export type NotificationPriority = "security" | "urgent" | "transactional" | "informational";

export interface NotificationSummary {
  readonly id: string;
  readonly title: string;
  readonly body: string;
  readonly priority: NotificationPriority;
  readonly deepLink: string | null;
  readonly createdAt: string;
  readonly readAt: string | null;
  readonly requiresAcknowledgement: boolean;
}

export interface NotificationRow {
  readonly id: string;
  readonly title: string;
  readonly body: string;
  readonly priority: NotificationPriority;
  readonly deep_link: string | null;
  readonly created_at: string;
  readonly read_at: string | null;
  readonly acknowledged_at: string | null;
  readonly requires_acknowledgement: boolean;
}

export function unreadCount(notifications: readonly NotificationSummary[]): number {
  return notifications.filter((notification) => notification.readAt === null).length;
}

export function toNotificationSummary(row: NotificationRow): NotificationSummary {
  return {
    id: row.id,
    title: row.title,
    body: row.body,
    priority: row.priority,
    deepLink: row.deep_link,
    createdAt: row.created_at,
    readAt: row.read_at,
    requiresAcknowledgement: row.requires_acknowledgement && !row.acknowledged_at,
  };
}

export function urlBase64ToUint8Array(value: string): Uint8Array<ArrayBuffer> {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const decoded = globalThis.atob(base64);
  return Uint8Array.from(decoded, (character) => character.charCodeAt(0));
}
